import { render } from "./PubliciteAqui.vue?vue&type=template&id=58b105d4"
const script = {}

import "./PubliciteAqui.vue?vue&type=style&index=0&id=58b105d4&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__